/* eslint-disable react/prop-types */
// import { useState } from "react";
import "./AddSlide.css";
// import Button from "@mui/material/Button";
// import AddIcon from "@mui/icons-material/Add";

//DB imports
import { db } from "../../firebaseConfig";
import { doc, updateDoc, getDoc } from "firebase/firestore";

const makeId = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

function AddSlide({ viewId, onSlideCreated }) {
  const handleAddSlide = async () => {
    const newId = makeId(10);

    const newSlide = {
      id: newId,
    };

    // Save the updated components array to Firestore
    const docRef = doc(db, "views", viewId); // Ensure you have a valid document reference
    let slidesArray = [];

    try {
      const docSnap = await getDoc(docRef); // Get the current document snapshot
      if (docSnap.exists()) {
        // If document exists, retrieve the existing details
        const data = docSnap.data();
        slidesArray = data.slides ?? [];

        // // Extracting title from content (if needed)
        // const firstTextEditor = contentsArray.find((comp) => comp.type === "text-editor");
        // if (firstTextEditor && !data.title) {
        //   const text = firstTextEditor.content.replace(/<[^>]*>/g, "");
        //   const words = text.split(" ").filter(Boolean);
        //   title = words.length > 3 ? words.slice(0, 3).join(" ") : text;
        // }
      } else {
        console.error("Error saving slide to Firestore. View not found:", viewId);
        return false;
      }

      // console.log("initial slidesArray", slidesArray);

      // Integrate new components and handle the IDs
      const index = slidesArray.findIndex((c) => c.id === newSlide.id);
      if (index !== -1) {
        slidesArray[index] = newSlide;
      } else {
        slidesArray.push(newSlide); // Add new component
      }
      // console.log("updated slidesArray", slidesArray);

      // Set the document with updated details
      await updateDoc(docRef, { slides: slidesArray });
      console.log("Slides updated successfully in Firestore.");
    } catch (error) {
      console.error("Error updating Firestore:", error);
    }

    // Call the onElementCreated callback
    if (onSlideCreated) {
      onSlideCreated(newSlide.id);
    }
  };

  return (
    // <div className="add-slide">
      <button onClick={handleAddSlide} className="open-menu-Btn-text">
        <span className="icon">+ </span>
      </button>
    // </div>
  );
}

export default AddSlide;
